var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("localeController", [
    "$rootScope",
    function (
        $rootscope
    ) {
        // #region Locale Related
        $rootscope.locales = [
            {
                title: "English | USD",
                icon: "fas fa-flag-usa",
                lang: "en-us",
                url: ""
            },
            {
                title: "French | EUR",
                icon: "fas fa-flag",
                lang: "fr-fr",
                url: ""
            }
        ];

        // Function to get the current locale from localStorage or default to English
        function getCurrentLocale() {
            var selectedLocale = 'en-us';
            if (window.location.href.toLowerCase().indexOf('.fr') > -1)
                selectedLocale = 'fr-fr';
            return $rootscope.locales.filter(function (locale) {
                return locale.lang === selectedLocale;
            })[0];
        }

        // Initialize the current locale
        $rootscope.currentLocale = getCurrentLocale();

        if (window.__env && window.__env.showLocale) {
        $rootscope.showLocale = window.__env.showLocale;
            $rootscope.onLocaleClick = function () {
                // Toggle the locale active state
                $rootscope.isLocaleActive = !$rootscope.isLocaleActive;
            };

            $rootscope.onLocaleSelected = function (lang) {
                // Find the selected locale
                var selectedLocale = $rootscope.locales.filter(function (locale) {
                    return locale.lang === lang;
                })[0];

                if (selectedLocale) {
                    // Store the selected locale in localStorage
                    localStorage.setItem('selectedLocale', lang);

                    // Update the current locale
                    $rootscope.currentLocale = selectedLocale;

                    // Get the current URL
                    var currentUrl = window.location.href;

                    // Determine the new URL based on the selected locale
                    var newUrl;
                    if (lang === 'fr-fr') {
                        // Replace '.com' with '.fr' to switch to the French domain
                        newUrl = currentUrl.replace('.com', '.fr');
                    } else {
                        // Replace '.fr' with '.com' to switch to the English domain
                        newUrl = currentUrl.replace('.fr', '.com');
                    }

                    // Construct the home page URL
                    var homePageUrl = new URL('/', newUrl).href;

                    // Redirect to the home page
                    window.location.href = homePageUrl;
                }
            };
        }

        // Ensure the initial locale is correctly set in the scope
        $rootscope.$applyAsync(function () {
            $rootscope.currentLocale = getCurrentLocale();
        });
        $rootscope.localeVariables = {};
        $rootscope.setLocaleVariables = function (key, value) {
            if (angular.isDefined(key) && angular.isDefined(value) && angular.isUndefined($rootscope.localeVariables[key])) {
                $rootscope.localeVariables[key] = value;
            }
        }
        //#endregion
    },
])
